// extracted by css-extract-rspack-plugin
export default {"cls1":"MentionsCardHeader-cls1_kNN","cls2":"MentionsCardHeader-cls2_CqW MentionsCardHeader-cls1_kNN"};